// extracted by mini-css-extract-plugin
module.exports = {"progressDotWrapper":"rfiStepperProgress_progressDotWrapper__3Syz1","dotWithBorder":"rfiStepperProgress_dotWithBorder__3ziRv","active":"rfiStepperProgress_active__BJlEm"};